import React from "react";
import LinkButton from "./../Button/LinkButton/LinkButton";
import { fToNowAr } from "../../utils/format";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { deleteNotificationAction } from "../../store/notification/notificationsActions";
import { useDispatch } from "react-redux";

export default function Notification({ data }) {
  const dispatch = useDispatch();

  const handleDelete = async () => {
    try {
      dispatch(deleteNotificationAction(data.id));
    } catch (error) {
      console.log(error);
    }
  };

  const handelNotification = () => {
    return (
      <div style={{ width: "100%" }}>
        <div className="close">
          <i
            className="fas fa-times close-btn" onClick={handleDelete}
          ></i>
        </div>
        <div className="noti-wrap tweet tweet-container">
          <span className="noti-msg">
            <h3>{data.title}</h3>
            <p>{data.description}</p>
          </span>
          <div className="noti-btn-cont">
            <span className="noti-time">{fToNowAr(data.created_at)}</span>
            {data.topic_id && (
              <LinkButton
                linkText="عرض المشروع"
                href={"/status/" + data.topic_id}
                className="tweet-btn"
                onClick={handleDelete}
              />
            )}
          </div>
        </div>
      </div>
    );
    // switch (data.notificationType) {
    //   case "follow":
    //     return (
    //       <Link to={"/status/" + data.topic_id}>
    //       <div className="noti-wrap">
    //           <span className="noti-msg">

    //             {data.title}

    //           </span>
    //           <span className="noti-time">{moment(data.createdAt).fromNow()}</span>
    //         </div>
    //       </Link>
    //     );
    //     case "like":
    //       return (
    //         <>
    //           <div className="wrap-avatar">
    //             <img
    //               src={data.sender.avatar}
    //               className="user-avatar"
    //               alt="avatar"
    //               title={data.sender.fullName}
    //             />
    //           </div>
    //           <div className="noti-wrap">
    //             <span className="noti-msg">
    //               <Link
    //                 to={"/" + data.sender.username}
    //                 className="user-username default-link"
    //               >
    //                 {"@" + data.sender.username}
    //               </Link>{" "}
    //               liked your <Link
    //                 to={"/" + data.sender.username+'/status/'+data.data.tweetid}
    //                 className="user-username default-link"
    //               >
    //                 post
    //               </Link>
    //             </span>
    //             <span className="noti-time">{moment(data.createdAt).fromNow()}</span>
    //           </div>
    //         </>
    //       )
    //       case "retweet":
    //         return (
    //           <>
    //             <div className="wrap-avatar">
    //               <img
    //                 src={data.sender.avatar}
    //                 className="user-avatar"
    //                 alt="avatar"
    //                 title={data.sender.fullName}
    //               />
    //             </div>
    //             <div className="noti-wrap">
    //               <span className="noti-msg">
    //                 <Link
    //                   to={"/" + data.sender.username}
    //                   className="user-username default-link"
    //                 >
    //                   {"@" + data.sender.username}
    //                 </Link>{" "}
    //                 retweeted your <Link
    //                   to={"/" + data.sender.username+'/status/'+data.data.tweetid}
    //                   className="user-username default-link"
    //                 >
    //                   post
    //                 </Link>
    //               </span>
    //               <span className="noti-time">{moment(data.createdAt).fromNow()}</span>
    //             </div>
    //           </>
    //         )
    //   case "comment":
    //     return (
    //       <>
    //         <div className="wrap-avatar">
    //           <img
    //             src={data.sender.avatar}
    //             className="user-avatar"
    //             alt="avatar"
    //             title={data.sender.fullName}
    //           />
    //         </div>
    //         <div className="noti-wrap">
    //           <span className="noti-msg">
    //             <Link
    //               to={"/" + data.sender.username}
    //               className="user-username default-link"
    //             >
    //               {"@" + data.sender.username}
    //             </Link>{" "}
    //             dropped comment on your <Link
    //               to={"/" + data.sender.username+'/status/'+data.data.tweetid}
    //               className="user-username default-link"
    //             >
    //               post
    //             </Link>
    //           </span>
    //           <span className="noti-time">{moment(data.createdAt).fromNow()}</span>
    //         </div>
    //       </>
    //     )
    //   default:
    //     return null;
    // }
  };
  return (
    <motion.div
      className="notification"
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
    >
      {handelNotification()}
    </motion.div>
  );
}
